<template>
  <div class="flex flex-col w-full overflow-hidden">
    <div class="w-full h-full flex-grow overflow-y-auto" @scroll="handleScroll">
      <div class="w-full max-w-content mx-auto">
        <div class="h-10" ref="spacer"></div>
        <base-back-button />
        <div class="px-4 sm:px-0">
          <h2 class="font-sans text-2xl uppercase mb-1" ref="pageTitle">{{ pageTitle }}</h2>
          <h3 class="text-neutral mb-2">Proceso en curso</h3>
          <div class="leading-1 mb-4">
            <p>El reconocimiento facial es una <strong>tecnología segura</strong> que le permitirá acceder a las instalaciones de forma rápida <strong>sin necesidad de presentar ningún documento</strong> en los tornos de entrada.</p>
          </div>
          <base-message-box>
            <template slot="content">
              <p>Al ser <strong>socio menor de edad</strong> necesitamos la autorización de sus progenitores / tutores legales para finalizar el proceso. Le recordamos que este proceso se mantendrá abierto hasta un <strong>máximo de 10 días</strong>, una vez pasado el plazo, deberá realizar nuevamente el trámite. No se repercutirá <strong>ningún coste si no se autoriza o finaliza</strong> el plazo descrito.</p>
            </template>
          </base-message-box>
          <div class="h-8"></div>
          <h4 class="font-bold text-xl mb-2">Cómo obtener la autorización</h4>
          <div class="prose leading-snug">
            <p>Si los progenitores o tutores legales <strong>son socios del RGCC</strong> deberán autorizar, cada uno de ellos, este proceso desde su área privada en el apartado de notificaciones. Para hacerlo, deberán ambos iniciar sesión con su usuario en este mismo portal web de accesos.</p>
            <p>Si alguno de los progenitores o tutores legales <strong>no es socio del RGCC</strong> deberá autorizar este proceso cumplimentando el PDF, que podrá descargar más abajo, entregándolo de forma presencial en las oficinas generales del RGCC ó a remitiéndolo al siguiente correo electrónico: autorizaciones@rgcc.es</p>
          </div>
          <div class="flex items-center bg-white p-4 shadow mt-6 rounded-lg space-x-3">
            <img src="@/assets/img/file-pdf.svg" />
            <div class="">
              <a :href="pdf.url" download class="text-secondary underline hover:text-secondary-900">Autorización reconocimiento facial menores</a>
              <span class="block text-sm text-slate-700">Documento PDF ({{ pdf.info.size }}, {{ pdf.info.pages }})</span>
            </div>
          </div>
          <p class="mt-6 prose leading-snug">Una vez el RGCC reciba la autorización o autorizaciones, el sistema de reconocimiento facial quedará activado.</p>
        </div>
        <div class="h-10"></div>
        <div class="px-4 sm:px-0"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleScrollMixin } from '@/mixins/appMixin'
import documents from '@/config/documents'

export default {
  name: 'BiometricConfigChild',
  mixins: [handleScrollMixin],
  data: function () {
    return {
      pdf: documents.authorization,
      pageTitle: 'Acceso biométrico menores de 14 años'
    }
  }
}
</script>

<style lang="scss" scoped></style>
